// Workspace testIds - central registry for QuoteDesk workspace UI
// See ./index.js for the recipe to add a new feature file.

export const WORKSPACE = {
  headerLogout: 'workspace-logout-btn',
  headerLangToggle: 'workspace-lang-toggle',
  sidebar: 'workspace-sidebar',
  uploadBtn: 'workspace-upload-btn',
  uploadInput: 'workspace-upload-input',
  searchInput: 'workspace-search-input',
  fileItem: (id) => `file-item-${id}`,
  fileMenuBtn: (id) => `file-menu-${id}`,
  renameBtn: (id) => `file-rename-${id}`,
  deleteBtn: (id) => `file-delete-${id}`,
  emptyState: 'workspace-empty-state',
  sidebarEmpty: 'sidebar-empty',
  grid: 'workspace-grid',
  gridStatus: 'grid-status-pill',
  gridReadonlyBanner: 'grid-readonly-banner',
  exportBtn: 'grid-export-btn',
  addRowBtn: 'grid-add-row-btn',
  addColBtn: 'grid-add-col-btn',
  sheetTab: (i) => `sheet-tab-${i}`,
  renameInput: 'rename-dialog-input',
  renameConfirm: 'rename-dialog-confirm',
  deleteConfirm: 'delete-dialog-confirm',
};

export const AUTH_EXTRA = {
  nameInput: 'auth-name-input',
  toggleModeBtn: 'auth-toggle-mode-btn',
  errorMsg: 'auth-error-msg',
};
